const urls = import.meta.glob('../assets/reward-trees/tree*.webp', {
  eager: true,
  query: '?url',
  import: 'default',
}) as Record<string, string>

const FULL = new Map<number, string>()
const BLANK = new Map<number, string>()

for (const [path, url] of Object.entries(urls)) {
  const blank = path.match(/tree(\d+)_blank-/)
  if (blank) {
    BLANK.set(Number(blank[1]), url)
    continue
  }
  const full = path.match(/tree(\d+)-/)
  if (full) FULL.set(Number(full[1]), url)
}

export function getRewardTreeAssets(gid: number) {
  return { full: FULL.get(gid), blank: BLANK.get(gid) }
}
